import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

function resetScrollPosition() {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

export default function ScrollToTop() {
  const location = useLocation();

  useLayoutEffect(() => {
    if (!("scrollRestoration" in window.history)) {
      return undefined;
    }

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    resetScrollPosition();
    const animationFrameId = window.requestAnimationFrame(resetScrollPosition);

    return () => window.cancelAnimationFrame(animationFrameId);
  }, [location.pathname, location.search, location.hash]);

  return null;
}
